import { rangeRelativeToDate } from '../../dateUtils';
import { getLatestValue } from '../../engine';
import { DataTable, DateRange, DateTrunc } from '../../models';
import { DefaultTimestampAccessor, ValueAccessor } from '../../models/Accessor';
import { Duration } from '../../models/Duration';

export const relativeToDateRangeWindow = (
  table: DataTable,
  relativeWindow: Duration,
  accessor: ValueAccessor<Date> = DefaultTimestampAccessor
): DateRange | undefined => {
  if (relativeWindow.unit === DateTrunc.NONE || relativeWindow.unit === DateTrunc.UNKNOWN) {
    return undefined;
  }
  const lastPoint = getLatestValue(table);
  if (!lastPoint || !accessor(lastPoint)) {
    return undefined;
  } else {
    return rangeRelativeToDate(accessor(lastPoint), relativeWindow);
  }
};
